import React from 'react'

import { PromotionStatusTag } from '@components/common/PromotionStatusTag'
import type { TableHeaders } from '@fourthwall/components'

import type { Promotion } from '../../../../Promotions.types'
import { PromotionCodeTableCell } from '../PromotionCodeTableCell/PromotionCodeTableCell'
import { PromotionUsageTableCell } from '../PromotionUsageTableCell/PromotionUsageTableCell'

export const TABLE_HEADERS: TableHeaders<Promotion> = [
  {
    id: 'code',
    label: 'Code',
    render: (promotion) => <PromotionCodeTableCell promotion={promotion} />,
    width: 5,
  },
  {
    id: 'status',
    label: 'Status',
    render: (promotion) => <PromotionStatusTag promotion={promotion} />,
    width: 3,
  },
  {
    id: 'used',
    label: 'Used',
    render: (promotion) => <PromotionUsageTableCell promotion={promotion} />,
  },
]
